import { Building } from './building.model';
import { MediaObject } from '../media-object.model';
import { RoomBooking } from './room-booking.model';

export class Room {
  /* Data from Exchange API */
  defaultHalfDayPrice: number;
  defaultFullDayPrice: number;
  building?: Building;
  roomBookings?: RoomBooking[];
  id?: string;
  pictures?: string[] | MediaObject[];
  available?: boolean;

  /* Data from NewTools API */
  kind?: string;
  etags?: string;
  resourceId?: string;
  resourceName?: string;
  generatedResourceName?: string;
  resourceType?: string;
  resourceEmail?: string;
  capacity?: number;
  buildingId?: string;
  floorName?: string;
  featureInstances?: any[];
  myGoogleData?: any;

  constructor(values: any = {}) {
    if (values !== null) {
      Object.assign(this, values);

      if (values.myGoogleData) {
        Object.assign(this, values.myGoogleData);
      }
    }
  }

  getResourceId(): string {
    return this.resourceId ?? this.myGoogleData.resourceId;
  }
}
